import o from"styled-components";import{theme as i}from"../../../../../theme.js";const a=o.div`
  display: flex;
  flex-direction: column;
  gap: ${i.spacing*4}px;
  padding: 0 ${i.spacing*4}px;
  height: fit-content;
  box-sizing: border-box;
  @media screen and (max-width: ${i.breakpoints.md}) {
    padding: ${i.spacing*4}px;
  }
`,e=o.div`
  background-color: ${i.colors.gray[100]};
  border-radius: ${i.spacing}px;
  border: 2px solid ${({selected:r})=>r?i.colors.primary[500]:"transparent"};
  cursor: pointer;
  .picture {
    max-height: 250px;
    > img {
      display: block;
      margin: auto;
      width: 100%;
      max-height: 250px;
      object-fit: contain;
    }
  }
  .details {
    padding: ${i.spacing*4}px;
    display: flex;
    flex-direction: column;
    gap: ${i.spacing*2}px;
    .title {
      display: block;
      font-size: 16px;
      font-weight: 700;
      word-break: break-all;
      color: ${i.colors.gray[900]};
    }
    .url {
      display: block;
      font-size: 12px;
      word-break: break-all;
      color: ${i.colors.gray[600]};
    }
  }
`;export{a as ListContainer,e as ParsedLinkContainer};
